var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav',{attrs:{"pills":""}},_vm._l((_vm.items),function(item,index){return _c('b-nav-item',{key:index,staticClass:"text-uppercase",attrs:{"exact":"","exact-active-class":"active","to":item.to}},[_vm._v(_vm._s(item.text))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }